import { createFileRoute } from '@tanstack/react-router'

import MailroomPage from '@/features/mailroom/pages/customer/mailroom'

export const Route = createFileRoute('/_shell/mailroom')({ component: MailroomPage })
